import {
  CLEAR_FETCHED_PUPILS,
  SEARCH_PUPILS,
  SEARCH_PUPILS_FAILURE,
  SEARCH_PUPILS_SUCCESS,
  GET_PUPILS_DELIVERY_LOCATION,
  GET_PUPILS_DELIVERY_LOCATION_SUCCESS,
} from 'constants/ActionTypes';
import { CHILDREN_PER_PAGE } from "constants/Values";

export const clearFetchedPupils = () => ({
  type: CLEAR_FETCHED_PUPILS,
});

export const searchPupils = (filter, selectedPupilsIds, pageSize = CHILDREN_PER_PAGE) => ({
  type: SEARCH_PUPILS,
  payload: { filter, selectedPupilsIds, pageSize },
});

export const searchPupilsFailure = () => ({
  type: SEARCH_PUPILS_FAILURE,
});

export const searchPupilsSuccess = (fetchedPupils = [], pageCount) => ({
  type: SEARCH_PUPILS_SUCCESS,
  payload: { fetchedPupils, pageCount },
});

export const getPupilsDeliveryLocation = studentId => ({
  type: GET_PUPILS_DELIVERY_LOCATION,
  payload: { studentId },
});

export const getPupilsDeliveryLocationSuccess = payload => ({
  type: GET_PUPILS_DELIVERY_LOCATION_SUCCESS,
  payload,
});
